import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronBottom"><Path d="M20 9L12 17L4 9" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronBottom;
